import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import { LoadingState } from '../src/SpacesDropdownLoadingState.tsx';

export const SpacesDropdown: LoadableType<{
	closePopup?: (reason?: string | undefined) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown.tsx'
			)
		).SpacesDropdown,
});
export const SpacesDropdownLoader: LoadableType<{
	closePopup?: (reason?: string | undefined) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown.tsx'
			)
		).SpacesDropdown,
	loading: LoadingState,
});
